import { Verbiage } from '@infinitro/content';
import {} from '@infinitro/global';
export const termsAndConditions = [
    Verbiage.terms_and_conditions_1,
    Verbiage.terms_and_conditions_2,
    Verbiage.terms_and_conditions_3,
    Verbiage.terms_and_conditions_4,
    Verbiage.terms_and_conditions_5,
    Verbiage.terms_and_conditions_6,
    Verbiage.terms_and_conditions_7,
    Verbiage.terms_and_conditions_8,
    Verbiage.terms_and_conditions_9,
    Verbiage.terms_and_conditions_10,
    Verbiage.terms_and_conditions_11
];
